import { type DialogProps } from '@radix-ui/react-dialog';
import { DialogRoot, DialogContent } from '@discover-ui/dialog';
import CommandRoot from './root';

export type CommandDialogProps = DialogProps;

const CommandDialog = ({ children, ...props }: CommandDialogProps) => (
  <DialogRoot {...props}>
    <DialogContent className="overflow-hidden p-0 shadow-lg">
      <CommandRoot className="[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:size-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:size-5">
        {children}
      </CommandRoot>
    </DialogContent>
  </DialogRoot>
);

export default CommandDialog;
